import http from '@/httpAxios';

const uberDeliveryValidate: (storeUuid: string, address: string) => any = (
  storeUuid,
  address
) => {
  const url = `/online/v2/store/${storeUuid}/uber/delivery/validate?address=${address}`;
  return http.get(url);
};

const UberDirectService = {
  uberDeliveryValidate,
};

export default UberDirectService;
